import { render, staticRenderFns } from "./cmsFaq.vue?vue&type=template&id=e458da18"
import script from "./cmsFaq.vue?vue&type=script&lang=js"
export * from "./cmsFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports